import { useBoolState } from "@dvrt/react-tools";
import * as React from "react";
import { useEffect, useRef } from "react";
import { useDebugSettings } from "conference/tools";
import { Box, ListItemText, Menu, MenuItem, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckIcon } from "conference/components/icons";
import ControlPanelDialog from "./ControlPanelDialog";
import { DenseListItemIcon } from "conference/components/widgets";

const DebugMenu = ({ showControlPanel }: { showControlPanel: () => void }) => {
    const [isShowMenu, showMenu, hideMenu] = useBoolState();
    const theme = useTheme();
    const buttonRef = useRef<HTMLDivElement>(null);
    const debugSettings = useDebugSettings();

    return (
        <React.Fragment>
            <Box
                ref={buttonRef}
                onClick={showMenu}
                sx={{
                    cursor: "pointer",
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.getContrastText(theme.palette.secondary.main),
                    padding: "5px 4px 7px 4px",
                    borderRadius: 20,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <FontAwesomeIcon icon="bug" fixedWidth />
            </Box>
            <Menu
                anchorEl={buttonRef.current}
                open={isShowMenu}
                onClose={hideMenu}
                style={{ zIndex: useTheme().zIndex.modal + 2 }}
            >
                <MenuItem
                    dense
                    onClick={() => {
                        debugSettings.enabled = false;
                        hideMenu();
                    }}
                >
                    <DenseListItemIcon />
                    <ListItemText primary="Disable debug mode" />
                </MenuItem>
                <MenuItem
                    dense
                    onClick={() => {
                        showControlPanel();
                        hideMenu();
                    }}
                >
                    <DenseListItemIcon />
                    <ListItemText primary="Control panel" />
                </MenuItem>
                <MenuItem
                    dense
                    onClick={() => {
                        debugSettings.showSpeakerListInfoDialog = !debugSettings.showSpeakerListInfoDialog;
                        hideMenu();
                    }}
                >
                    <DenseListItemIcon>
                        {Boolean(debugSettings.showSpeakerListInfoDialog) && <CheckIcon />}
                    </DenseListItemIcon>
                    <ListItemText primary="Speaker-list info dialog" />
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

const DebugControls = () => {
    const [isShowControlPanel, showControlPanel, hideControlPanel, toggleControlPanel] = useBoolState();
    const debugSettings = useDebugSettings();

    useEffect(() => {
        window.addEventListener("keydown", (ev) => {
            if (ev.ctrlKey && ev.key === "d") toggleControlPanel();
        });
    }, []);

    return (
        <>
            {Boolean(debugSettings.enabled) && <DebugMenu showControlPanel={showControlPanel} />}
            <ControlPanelDialog show={isShowControlPanel} hide={hideControlPanel} />
        </>
    );
};

export default DebugControls;
